export default class Device {
  /**
   * PCか判定.
   * @returns {boolean}
   */
  static isPc() {
    return $(window).width() >= 800;
  }

  /**
   * SPか判定.
   * @returns {boolean}
   */
  static isMobile() {
    return $(window).width() < 800;
  }

  /**
   * Tabletか判定.
   * @returns {boolean}
   */
  static isTablet() {
    return $('#renewal').hasClass('is-tablet');
  }
}
